import React from "react";
import { Box, Button, Checkbox, MenuItem, Select, Table, TableHead, TableBody, TableCell, TableRow } from "@mui/material";
import { MappingData } from "types/models/support/SupportApp";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";

interface MappingTableProps {
  mapping: MappingData[];
  dynamicRows: any[];
  handleRowChange: (index: number, field: string, value: any) => void;
}

const MappingTable: React.FC<MappingTableProps> = ({ mapping, dynamicRows, handleRowChange }) => {
  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading />
        </TableHead>
        <TableBody>
          {/* Render dynamic rows */}
          {dynamicRows.map((row, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>
                <Select
                  value={row.crmCategory}
                  onChange={(e) => handleRowChange(index, "crmCategory", e.target.value)}
                  fullWidth
                >
                  <MenuItem value="Billing">Billing</MenuItem>
                  <MenuItem value="Technical">Technical</MenuItem>
                </Select>
              </TableCell>
              <TableCell>
                <Select
                  value={row.clientCategory}
                  onChange={(e) => handleRowChange(index, "clientCategory", e.target.value)}
                  fullWidth
                >
                  <MenuItem value="Assistance Required">Assistance Required</MenuItem>
                  <MenuItem value="Technical Issue">Technical Issue</MenuItem>
                </Select>
              </TableCell>
              <TableCell>
                {["FTTIN", "FTTH/B", "MassOutage"].map((condition) => (
                  <Box key={condition}>
                    <Checkbox
                      checked={!!row.conditions[condition]}
                      onChange={() => handleRowChange(index, "conditions", condition)}
                    />
                    {condition}
                  </Box>
                ))}
              </TableCell>
              <TableCell>
                <Checkbox
                  checked={row.status}
                  onChange={(e) => handleRowChange(index, "status", e.target.checked)}
                />
              </TableCell>
              <TableCell>
                <Button variant="contained" color="primary">
                  Save
                </Button>
              </TableCell>
            </TableRow>
          ))}
           {/* Render mapping data */}
           {mapping.map((data) => (
            <TableItem data={data} key={data.sNo} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default MappingTable;
